export default ({ formComponents }) => {
  const { select, input } = formComponents;
  return {
    root: {
      position: 'relative',

      '& svg': {
        fill: ({ dark }) => (dark ? select.darkIconFill : select.iconFill),
        pointerEvents: 'none',
        position: 'absolute',
        right: select.caretRight,
        top: select.caretTop,
        display: select.caretIcon
      }
    },

    select: {
      appearance: 'none',
      '&::-ms-expand': {
        // necessary evil for IE 11, appearance should work in edge
        display: 'none'
      },
      background: input.backgroundColor,
      border: input.border,
      borderColor: ({ error, dark, warning }) => !!error && (dark ? (
        warning ? formComponents.dark.warning.borderColor : formComponents.dark.error.borderColor
      ) : (
        warning ? formComponents.warning.borderColor : formComponents.error.borderColor
      )),
      borderRadius: input.borderRadius,
      color: ({ dark }) => (dark ? input.darkColor : input.color),
      fontFamily: input.fontFamily,
      fontSize: input.fontSize,
      fontWeight: input.fontWeight,
      lineHeight: 1,
      padding: select.padding,
      width: '100%',

      '& option': {
        color: ({ dark }) => (dark ? select.darkOptionColor : select.optionColor),
        backgroundColor: ({ dark }) => (
          dark
            ? select.darkOptionBackground
            : select.optionBackground)
      },

      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: '#EDEDED',
        opacity: 1
      },

      '&:focus': {
        outlineColor: ({ dark }) => (dark ? select.darkFocusColor : select.focusColor)
      }
    },
    caret: {
      ...select.caret
    }
  };
};
